import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { ResourceService } from '@teem/generic/resource.service';
import { Expense, ExpenseSerializer } from '@teem/models/expense';
import { expense as ExpenseApi } from '@teem/constants/api';

@Injectable({
	providedIn: 'root'
})
export class ExpenseService extends ResourceService<Expense> {

	constructor(httpClient: HttpClient) {
		super(
			httpClient,
			ExpenseApi.endPoint,
			new ExpenseSerializer()
		)
	}

	public commonData() {
		return this.httpClient.get(`${ExpenseApi.common}`, this.httpOptions);
	}

	public refundExpense(uuid: string) {
		return this.httpClient.get(`${ExpenseApi.refundExpense(uuid)}`);
	}
}